import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'

import { showAppLoader, hideAppLoader } from '../app';

export const register = (data) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/user/register', data)
    .then((response) => {
      dispatch(hideAppLoader())
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const signUp = (data) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/temp/sign-up', data)
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response;
    })
    .catch((ex) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      // if (ex instanceof ReferenceError) {
      // }
      return ex;
    });
};
export const accountActivation = (data) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/temp/account-activation', data)
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response;
    })
    .catch((ex) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      // if (ex instanceof ReferenceError) {
      // }
      return ex;
    });
};
export const setupIntent = (data) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/temp/setupIntent', data)
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      // if (ex instanceof ReferenceError) {
      // }
      return ex;
    });
};

export const buyerPaymentValidate = (token, id) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/buyer-payment-validate/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const setupIntentGet = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/paymentMethod/setupIntent', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const promoCodeApi = (promoCodeId) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/user/promocode/validate/' + promoCodeId)
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const promoCodeUpdateApi = (data) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/user/newPromoCode/addExistingPromoCode/', data)
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response;
    })
    .catch((ex) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      // if (ex instanceof ReferenceError) {
      // }
      return ex;
    });
};
export const diverseSpendListFetchApi = () => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/user/tracking_list')
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};